import React, {useContext, useEffect, useState} from 'react';
import { useNavigate } from "react-router-dom";
import { InputContext } from '../contexts/InputContext';
import BotonVolver from '../components/BotonVolver';

const Ayuda = () => {
  const navigate = useNavigate();
  const [authInformation, setAuthInformation] = useContext(InputContext)
  const [renderHTML, setRenderHTML] = useState(false)

  const [videoElegido, setVideoElegido] = useState({
    titulo: '',
    id_enlace: ''
  })


  const linksObligado = [
    { titulo: 'Cómo ingresar a ver las notificaciones ? ',
    id_enlace: 'Qt9M9eV7kAw?si=kLx62sASzf4nrqJ2' },
    { titulo: 'Cómo hacer una declaración jurada ? ',
    id_enlace: 'C0S2407__2s?si=6Mo2LiMlyzvejpPM' },
    { titulo: 'Cómo recuperar la contraseña ?',
    id_enlace: 'llWWqtVgZ2s?si=-ddX_8G6rzq_Iemu' },
    { titulo: 'Cómo cambiar la contraseña ?',
    id_enlace: 'e_VU1VwpP4w?si=0C77HKUu1coEbz78' },
  ]

  const linksMesaDeEntrada = [
    { titulo: 'Cómo Aprobar o Rechazar una declaración jurada ? ',
    id_enlace: 'WwkGWVqaUEQ?si=85l9XRwRL61DStSf' },
    { titulo: 'Cómo recuperar la contraseña ?',
    id_enlace: 'llWWqtVgZ2s?si=-ddX_8G6rzq_Iemu' },
    { titulo: 'Cómo cambiar la contraseña ?',
    id_enlace: 'e_VU1VwpP4w?si=0C77HKUu1coEbz78' },
  ]

  const linksNotificadores = [
    { titulo: 'Cómo crear una notificación ?',
    id_enlace: 'bhADDsia4dI?si=uMv823NznOtF1vTv' },
    { titulo: 'Cómo recuperar la contraseña ?',
    id_enlace: 'llWWqtVgZ2s?si=-ddX_8G6rzq_Iemu' },
    { titulo: 'Cómo cambiar la contraseña ?',
    id_enlace: 'e_VU1VwpP4w?si=0C77HKUu1coEbz78' },
  ]

  const linksVeedores = [
    { titulo: 'Cómo recuperar la contraseña ?',
    id_enlace: 'llWWqtVgZ2s?si=-ddX_8G6rzq_Iemu' },
    { titulo: 'Cómo cambiar la contraseña ?',
    id_enlace: 'e_VU1VwpP4w?si=0C77HKUu1coEbz78' },
  ]

  const CardAyuda = ({titulo, id_enlace}) => {
    return (
      <div className='card text-center'>
        <div className='card-body'>
          <h5 className='card-title'>{titulo}</h5>
          <button type="button" className="btn btn-outline-dark" onClick={() => setVideoElegido({titulo, id_enlace})} data-bs-toggle="modal" data-bs-target="#videoYoutube" >Ver video</button>
        </div>
      </div>
    )
  }

  useEffect(() => {
    if(authInformation.autenticado === false){
      navigate(`/ingreso`);
    } else if( authInformation.autenticado === true){
      setRenderHTML(true)
    } else {
      setRenderHTML(false)
    }
  }, [authInformation]);


  return (
    <div>
      <h1>Ayuda <BotonVolver /></h1>
      {/* <h5>Podés solicitar ayuda escribiendo al correo <b>mail@tcneuquen.gov.ar</b></h5> */}
      {renderHTML && (
        <>
          <div className='row'>
            {(authInformation.rol === 'Obligado' || authInformation.rol === 'Apoderado') &&  (
              linksObligado.map((p, i) => (
                <div key={i} className='col-md-6 mb-3'>
                  <CardAyuda titulo={p.titulo} id_enlace={p.id_enlace} />
                </div>
                ))
            )}
            {(authInformation.rol === 'MesaEntrada') &&  (
              linksMesaDeEntrada.map((p, i) => (
                <div key={i} className='col-md-6 mb-3'>
                  <CardAyuda titulo={p.titulo} id_enlace={p.id_enlace} />
                </div>
                ))
            )}
            {(authInformation.rol === 'Notificador') &&  (
              linksNotificadores.map((p, i) => (
                <div key={i} className='col-md-6 mb-3'>
                  <CardAyuda titulo={p.titulo} id_enlace={p.id_enlace} />
                </div>
                ))
            )}
            {(authInformation.rol === 'Veedor') &&  (
              linksVeedores.map((p, i) => (
                <div key={i} className='col-md-6 mb-3'>
                  <CardAyuda titulo={p.titulo} id_enlace={p.id_enlace} />
                </div>
                ))
            )}
          </div>

          <div className="modal fade" data-bs-backdrop="static" id="videoYoutube" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-xl">
              <div className="modal-content">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="exampleModalLabel">{videoElegido.titulo}</h1>
                  <button type="button" className="btn-close text-dark" data-bs-dismiss="modal" aria-label="Close">X</button>
                </div>
                <div className="modal-body">
                  <div className='container-fluid text-center'>
                    <iframe className='embed-responsive-item' width='768' height='433' src={`https://www.youtube.com/embed/${videoElegido.id_enlace}&modestbranding=1&controls=0&amp;`} title={videoElegido.titulo} allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share' allowborder='0' allowFullScreen></iframe>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Ayuda;